import React from 'react'
import {
  differenceInDays,
  format,
  isBefore,
  parse,
  parseISO,
  startOfDay,
} from 'date-fns'

import DatePicker from 'common/components/datePicker'
import Input from 'common/components/input'
import { isYesterdayOrBefore } from 'common/helpers/date'

type Props = {
  defaultValue: string
  name: string
  type: string
  required: string
  disabled: boolean
  onChange: Function
  daysToGoDate: any
  stepProps?: Object
  format: string
  value: any
}

type State = {
  daysToGo: number
  daysUpdatedManually: boolean
  hideDaySection: string
  calenderDate: Date | null
}
class DaysToGo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      daysToGo: 0,
      daysUpdatedManually: false,
      calenderDate: null,
      hideDaySection: 'none',
    }
    this.onDateChange = this.onDateChange.bind(this)
    this.onDaysChange = this.onDaysChange.bind(this)
    this.disabledDateTime = this.disabledDateTime.bind(this)
  }

  componentDidMount() {
    const { value } = this.props
    const { calenderDate } = this.state
    if (calenderDate === null && value) {
      this.setState({
        calenderDate: value,
      })
    }
  }

  componentDidUpdate(prevProps: Props) {
    const { daysToGoDate, defaultValue, onChange, name, type, required } =
      this.props
    const selectedDate = defaultValue.split('||')[0]
    if (prevProps.defaultValue !== defaultValue && defaultValue) {
      const checkDate = defaultValue.split('||')
      // checkDate[0] is 'DD-MM-YYYY', reverse to get 'YYYY-MM-DD'
      const calDate = parse(checkDate[0], 'dd-MM-yyyy', new Date())
      const daysToGoDateParsed = daysToGoDate
        ? parseISO(daysToGoDate)
        : new Date()
      this.setState({
        calenderDate: calDate,
        daysToGo:
          checkDate.length > 1
            ? Number(checkDate[1])
            : differenceInDays(calDate, daysToGoDateParsed),
        hideDaySection: '',
      })
    }
    // selectedDate is 'DD-MM-YYYY', reverse to 'YYYY-MM-DD' for Date parsing
    const formatedDate = selectedDate
      ? selectedDate.split('-').reverse().join('-')
      : ''
    if (
      new Date(formatedDate).getTime() < new Date(daysToGoDate).getTime() &&
      this.state.calenderDate !== null
    ) {
      this.setState(
        {
          calenderDate: null,
          daysToGo: 0,
        },
        onChange(name, type, '', required)
      )
    }
  }

  onDateChange(calenderDate: Date | null) {
    const { daysToGoDate } = this.props
    if (!calenderDate) {
      this.setState(
        {
          calenderDate: null,
          daysToGo: 0,
          daysUpdatedManually: false,
          hideDaySection: 'none',
        },
        this.parentOnChange
      )
    } else {
      const daysToGoDateParsed = daysToGoDate
        ? parseISO(daysToGoDate)
        : new Date()
      const daysToGo = differenceInDays(calenderDate, daysToGoDateParsed)
      this.setState(
        {
          calenderDate,
          daysToGo,
          daysUpdatedManually: false,
          hideDaySection: '',
        },
        this.parentOnChange
      )
    }
  }

  onDaysChange(e: any) {
    const { calenderDate } = this.state
    const daysToGo =
      parseInt(e.target.value, 10) ||
      (calenderDate ? differenceInDays(calenderDate, new Date()) : 0)
    this.setState(
      {
        daysToGo,
        daysUpdatedManually: true,
      },
      this.parentOnChange
    )
  }

  parentOnChange() {
    const { calenderDate, daysUpdatedManually, daysToGo } = this.state
    const { onChange, name, type, required } = this.props
    let value = ''
    if (calenderDate) {
      value = format(calenderDate, 'dd-MM-yyyy')
      if (daysUpdatedManually) {
        value += `||${daysToGo}`
      }
    }
    onChange(name, type, value, required)
  }

  disabledDateTime(current: Date) {
    const { daysToGoDate } = this.props
    if (daysToGoDate) {
      const today = startOfDay(new Date())
      const sendDate = startOfDay(parseISO(daysToGoDate))
      if (!isBefore(sendDate, today)) {
        // today is on or before sendDate: enable sendDate and later
        return isBefore(startOfDay(current), sendDate)
      }
    }
    return isYesterdayOrBefore(current)
  }

  render() {
    const { disabled } = this.props
    const { calenderDate, hideDaySection, daysToGo } = this.state
    return (
      <div>
        <DatePicker
          date={calenderDate}
          onDateChange={this.onDateChange}
          id="date"
          disabled={disabled}
          appendToBody
          openDirection="up"
          isOutsideRange={this.disabledDateTime}
          isTodayVisible={true}
        />
        <p
          className="leading-normal mt-2 text-coolGray-400"
          style={{ display: hideDaySection }}
        >
          {'Your sale will end on the day selected, do you want to say'}{' '}
          <div className="inline-flex text-coolGray-600">
            <Input
              variant="small"
              type="text"
              value={daysToGo.toString()}
              onChange={this.onDaysChange}
            />
          </div>{' '}
          days to go? If not please update.
        </p>
      </div>
    )
  }
}

export default DaysToGo
